import type { AppLocale } from './locale';
import { DEFAULT_LOCALE } from './locale';

/**
 * 사용자용 도움말 docs 사이트의 production base URL.
 * "?" 도움말 버튼은 환경과 무관하게 항상 production docs를 가리킨다.
 */
export const DOCS_BASE_URL = 'https://docs.agentteams.run';

/**
 * 사이드바 각 페이지 → docs 사이트 `workflows/*` 슬러그 매핑.
 * 슬러그는 docs/content/{locale}/workflows/<slug>.mdx 와 일치한다.
 */
export const USECASE_DOCS_SLUG = {
  plans: 'plan',
  'co-actions': 'co-action',
  'completion-reports': 'completion-reports',
  conventions: 'convention',
  'daemon-triggers': 'daemon-triggers',
  'post-mortems': 'post-mortem',
  'agent-configs': 'agent-configs',
  'code-reviews': 'code-review',
  documents: 'documents',
} as const;

export type UsecaseDocsKey = keyof typeof USECASE_DOCS_SLUG;

/**
 * 워크플로우 도움말 docs 페이지의 절대 URL을 만든다.
 * 예: getUsecaseDocsUrl("plans", "ko") → https://docs.agentteams.run/ko/workflows/plan
 */
export const getUsecaseDocsUrl = (key: UsecaseDocsKey, locale: AppLocale = DEFAULT_LOCALE): string => {
  return `${DOCS_BASE_URL}/${locale}/workflows/${USECASE_DOCS_SLUG[key]}`;
};

/**
 * 온보딩(시작하기) 도움말 docs 페이지의 절대 URL.
 * 프로필 메뉴의 "온보딩 가이드" 진입점이 가리킨다.
 */
export const getOnboardingDocsUrl = (locale: AppLocale = DEFAULT_LOCALE): string => {
  return `${DOCS_BASE_URL}/${locale}/getting-started/quickstart`;
};

/**
 * 임의의 docs 페이지 절대 URL을 만든다. (예: "setup/cli-install")
 */
export const getDocsUrl = (path: string, locale: AppLocale = DEFAULT_LOCALE): string => {
  const normalized = path.replace(/^\/+/, '');
  return `${DOCS_BASE_URL}/${locale}/${normalized}`;
};
